import React from 'react';
import { Form, Spin } from 'antd';
import { Message, Icon } from 'semantic-ui-react';

class FiledUpload extends React.Component {
  render() {
    const { uploadLoading, attachments, label } = this.props;
    return (
      <Form.Item label={label} className="fluid-field">
        <Message className="upload-box">
          {!attachments ? (
            <div className="upload-file">
              {uploadLoading && <Spin />}
              <input type="file" /> Click here to upload
            </div>
          ) : (
            attachments.map((i, idx) => (
              <div key={idx} className="file-info">
                <div className="file-info-inner">
                  <Icon name="file alternate" />
                  <div className="file-name">{i.Title}</div>
                </div>
                <div className="file-actions">
                  <Icon name="download" />
                  <Icon name="delete" color="red" />
                </div>
              </div>
            ))
          )}
        </Message>
      </Form.Item>
    );
  }
}

export default FiledUpload;
